<template>
    <AdministrativeCenterFB2B v-if="isFaceB2B" :send-type="SendType" :loading="loading" />
    <AdministrativeCenter v-else :send-type="SendType" :loading="loading" />
</template>

<script>
import AdministrativeCenter from '@/views/configuration/AdministrativeCenter.vue'
import AdministrativeCenterFB2B from '@/views/configuration/AdministrativeCenterFB2B.vue'
import { getSede } from '@/services/configurations/getSede'


export default {
  name: 'administrative-centers-handler',
  components: {
    AdministrativeCenter,
    AdministrativeCenterFB2B
  },
  data: function () {
    return {
      SendType: '',
      loading: false
    }
  },
  mounted () {
  },
  computed: {
    isFaceB2B: function () {
      return this.SendType === 'FACEB2B'
    },
    id () {
      return parseInt(this.$route.params.id)
    },
    idSede () {
      return parseInt(this.$route.params.idSede)
    },
  },
  async created () {
    var sendType = ''
    if (this.$store.getters['app/fromRouteName'] !== null) {
      sendType = this.$store.getters['app/stateBreadCrumb']
    } else {
      const sede = await this.downloadData()
      const cabecera = sede.LocationName || ' '
      sendType = sede.SendType
      this.$store.commit('app/setheaderBreadCrumb', cabecera)
      this.$store.commit('app/setstateBreadCrumb', sendType)
    }

    // Si NO es FACEB2B forzar remount, para carga de datos correcta.
    if (sendType !== 'FACEB2B') {
      this.loading = true
      this.SendType = 'FACEB2B'
      await this.$nextTick()
    }

    this.loading = false
    this.SendType = sendType
  },
  methods: {
    downloadData: async function () {
      let contact = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          IdSociedad: this.id,
          IdSede: this.idSede
        }
        contact = await getSede(params)
        if (contact.blnError === true) {
          this.doFeedback(`${contact.msgError} [${contact.codError}]`)
        } else {
          contact = contact.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return contact
    },
  }
}
</script>
